import React from 'react';
import { v4 } from 'uuid';
import { Alert, Box, Grid } from '@mui/material';
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone';

import CommonHeader from '../../Partials/CommonHeader';
import LoadingCard from '../../../../Components/LoadingCard';
import DeviceEvents from './Partials/DeviceEvents';
import DeviceControl from './Partials/DeviceControl';
import ExtendedDeviceInfo from '../GenericDevice/Partials/ExtendedInfo';
import DeviceInfo from './Partials/DeviceInfo';
import DeviceSettings from './Partials/DeviceSettings';
import CommandPanel from '../../Partials/command-panel';
import { formatMoveEvent, getConfigChanges } from '../../modules/moveEvents';

export default function DeviceValidation(props: ValidationProps) {
  const [deviceConfig, setDeviceConfig] = React.useState<
    DeviceConfig | undefined
  >();

  const [events, setEvents] = React.useState<MoveEvent[]>([]);
  const handleNewEvent = (data: any) => {
    let nextEvents = events;
    console.log('processing event', data);
    try {
      if (data.event.parent === props.device.addresses[0].address) {
        const changes = getConfigChanges(data.event);
        if (changes) {
          setDeviceConfig((prev) => prev && { ...prev, ...changes });
        }
        nextEvents = [formatMoveEvent(data.event), ...events];
      }
    } catch {}
    setEvents(nextEvents);
  };

  const handleConfigUpdate = (newConfig: any) => {
    if (newConfig && newConfig.parms) {
      newConfig.parms.deviceId = newConfig.device_id;
      setDeviceConfig({
        ...newConfig.parms,
        createdAt: newConfig.created,
        lastPairedAt: newConfig.lastPairedAt,
        state: newConfig.state,
      });
      return;
    }
    const newEvent: MoveEvent = {
      account: '',
      created: new Date().toString(),
      id: v4(),
      media_key_1: '',
      name: '',
      parent: '',
      type: `updateConfig - ${JSON.stringify(newConfig)}`,
      updated: '',
    };
    setEvents([newEvent, ...events]);
  };

  props.moveClient.onConfigUpdate = handleConfigUpdate;
  props.moveClient.onNewEvent = handleNewEvent;
  props.moveClient.onNotification = handleNewEvent;

  const deviceConfigCB = React.useCallback(() => {
    if (!deviceConfig) {
      let deviceId = '';
      if (props.device.addresses.length !== 0) {
        deviceId = props.device.addresses[0].address;
      }
      if (deviceId !== '') {
        props.moveClient.onConfigUpdate = handleConfigUpdate;

        props.moveClient.getConfig(deviceId);
      } else {
        console.error('could not determine device id');
      }
    }
  }, [deviceConfig, setDeviceConfig, props.device, props.moveClient]);
  React.useEffect(deviceConfigCB, [deviceConfigCB, props.device]);

  const renderDevice = () => {
    return (
      <Grid item xs={12} container columnGap={4}>
        <Grid item xs={4}>
          <Box display="flex" flexDirection="column" rowGap={4}>
            <DeviceInfo config={deviceConfig} moveClient={props.moveClient} />
            <CommandPanel
              deviceId={props.device.addresses[0].address}
              moveClient={props.moveClient}
            />
            <DeviceControl
              deviceId={props.device.addresses[0].address}
              moveClient={props.moveClient}
              config={deviceConfig!}
            />
            <ExtendedDeviceInfo
              config={deviceConfig}
              moveClient={props.moveClient}
            />
          </Box>
        </Grid>
        <Grid item xs={7}>
          <Box display="flex" flexDirection="column" rowGap={4}>
            <Grid item xs={12} pt={2}>
              <Alert severity="info">
                This is a generic device validation view. Not all specific
                device features have been implemented.
              </Alert>
            </Grid>
            <DeviceSettings
              moveClient={props.moveClient}
              deviceId={props.device.addresses[0].address}
            />
            <DeviceEvents events={events} />
          </Box>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid item xs={12} container justifyContent="center" sx={{ pb: 4 }}>
      <Grid item xs={12}>
        <CommonHeader
          Icon={<SettingsTwoToneIcon fontSize="large" />}
          viewTitle={props.device.label}
          onChangeDevice={props.onChangeDevice}
        />
        {!deviceConfig && <LoadingCard msg="Getting Device Config" />}
        {deviceConfig && renderDevice()}
      </Grid>
    </Grid>
  );
}
